var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEEZ_PSP_UI_Icons",
    transform: "translate(-115.000000, -195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF20-icons-/-25-/-Tooltip",
    transform: "translate(110.500000, 190.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CED0DA",
    cx: 12.5,
    cy: 12.5,
    r: 7.29166667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2708333,11.71875 C12.6850469,11.71875 13.0208333,12.0545364 13.0208333,12.46875 L13.0208333,15.9166667 C13.0208333,16.3308802 12.6850469,16.6666667 12.2708333,16.6666667 L12.2083333,16.6666667 C11.7941198,16.6666667 11.4583333,16.3308802 11.4583333,15.9166667 L11.4583333,12.46875 C11.4583333,12.0545364 11.7941198,11.71875 12.2083333,11.71875 L12.2708333,11.71875 Z M12.2395833,9.375 C12.6710558,9.375 13.0208333,9.72477754 13.0208333,10.15625 C13.0208333,10.5877225 12.6710558,10.9375 12.2395833,10.9375 C11.8081109,10.9375 11.4583333,10.5877225 11.4583333,10.15625 C11.4583333,9.72477754 11.8081109,9.375 12.2395833,9.375 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTooltip);
export default __webpack_public_path__ + "static/media/icons_Tooltip.e1f1bfb1.svg";
export { ForwardRef as ReactComponent };